import { styled, Box, Typography } from '@mui/material'

export const StyledRegisterProspeccaoSection = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 20px;
`

export const StyledSectionTitle = styled(Typography)`
  color: var(--secondary-color);
  font-weight: bold;
  margin-bottom: 10px;
  line-height: 1.2;
`